import { ReactElement } from 'react'
import { I18n, Translate } from 'src/i18n'
import { MessageBox } from 'src/ui-components/util'
import styled from 'styled-components'
import _ from 'lodash'
import { Part } from '../../../../Common/interfaces'
import { useAddToListStore } from 'src/store/lists/AddToListStore'
import { Hyperlink } from 'src/ui-components/util/Hyperlink'
import { defaultTheme } from 'src/theme'
import { MessageBoxType } from 'src/ui-components/util/Interfaces'

interface Props {
  parts: Part[]
}

const Duplicate = (props: Props): ReactElement => {
  const { parts } = props
  const addToListStore = useAddToListStore()

  const title =
    parts?.length === 1
      ? `1 ${Translate(
          'itemFoundWithDuplicatePartNumbersFromDifferentManufacturers'
        )}`
      : `${Translate(
          'itemsFoundWithDuplicatePartNumbersFromDifferentManufacturers',
          [parts.length]
        )}`

  const groups = _(parts)
    .groupBy((x) => x.partNum)
    .map((value, key) => ({ partNum: key, parts: value }))
    .value()

  const message = ({ description, partNum, lineCode }: Part) =>
    `${description ?? Translate('unknownItem')}, ${Translate(
      'partNum'
    )} ${partNum}, ${Translate('lineCode')}: ${lineCode} `

  const matchesMsg = (partNum, matches) => (
    <span>
      <b>
        {Translate('partNum')} {partNum}
      </b>{' '}
      {Translate('hasNMatches', [matches])}
    </span>
  )

  const msgGroups = groups.map((g) => {
    const title = matchesMsg(g.partNum, g.parts?.length)
    const items = g.parts?.map((p) => {
      return { seqno: p.seqno, message: message(p) }
    })
    return { title, items }
  })

  return (
    <MessageBox title={title} type={MessageBoxType.WARNING} show>
      <BodyWrapper>
        {msgGroups.map((msgGroup, index) => (
          <p key={`duplicate_part_group_${index}`}>
            <span>{msgGroup.title}</span>
            <br />
            {msgGroup.items.map((item, i) => (
              <ItemWrapper key={`duplicate_item_${index}_${i}`}>
                <span>{item.message}</span>
                <Hyperlink
                  action={() => addToListStore.removePart(item.seqno)}
                  color={defaultTheme.colors.red}
                >
                  <I18n name="removeItem" />
                </Hyperlink>
                <br />
              </ItemWrapper>
            ))}
          </p>
        ))}
      </BodyWrapper>
    </MessageBox>
  )
}

const BodyWrapper = styled.div`
  padding: 1rem;
`

const ItemWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  margin: 5px 0px 5px 24px;
`

export default Duplicate
